var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19526 11.5282C6.45561 11.2678 6.87772 11.2678 7.13807 11.5282L10.6936 15.0837C10.954 15.3441 10.954 15.7662 10.6936 16.0265C10.4333 16.2869 10.0112 16.2869 9.75082 16.0265L6.19526 12.471C5.93491 12.2106 5.93491 11.7885 6.19526 11.5282Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8047 7.97261C18.0651 8.23296 18.0651 8.65507 17.8047 8.91541L10.6936 16.0265C10.4333 16.2869 10.0112 16.2869 9.75082 16.0265C9.49047 15.7662 9.49047 15.3441 9.75082 15.0837L16.8619 7.97261C17.1223 7.71226 17.5444 7.71226 17.8047 7.97261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToastSuccess);
export default __webpack_public_path__ + "static/media/icon_toast_success.763a7d1833200841214a53af7c18a45b.svg";
export { ForwardRef as ReactComponent };